import React from 'react'
import './InboxStyle.css'
import { Select, ToggleSwitch } from '@enamelai/design-system'
import { type EmailInboxSettings } from '../useEmail'
import { Icon as InfoIcon } from '@enamelai/design-system/icons/Info'

const SHOW_IMAGES_OPTIONS = [
  { label: 'Ask before displaying', value: 'ask' },
  { label: 'Always display', value: 'always' },
  { label: 'Never display', value: 'never' },
]

const INBOX_TOGGLES: {
  key: keyof Pick<
    EmailInboxSettings,
    'notify_new_email' | 'show_unread_mail_indicator' | 'confirm_link_urls'
  >
  label: string
}[] = [
  { key: 'notify_new_email', label: 'Notify on new email' },
  { key: 'show_unread_mail_indicator', label: 'Show unread mail' },
  { key: 'confirm_link_urls', label: 'Confirm link URLs' },
]

type InboxTabProps = {
  data: EmailInboxSettings
  onChange: <K extends keyof EmailInboxSettings>(
    key: K,
    value: EmailInboxSettings[K],
  ) => void
}

const selectValue = (value: string | string[]): string =>
  Array.isArray(value) ? (value[0] ?? '') : value

const InboxTab = ({ data, onChange }: InboxTabProps): React.ReactElement => (
  <div className="scp-email-inbox">
    <span className="scp-email-inbox-section-title">
      Email inbox settings
      <span
        className="ds-section-card__icon-button"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Configure how incoming email is displayed and handled."
      >
        <InfoIcon aria-hidden="true" />
      </span>
    </span>

    <Select
      className="scp-email-inbox-select"
      label="Show images"
      value={data.show_images}
      options={SHOW_IMAGES_OPTIONS}
      onChange={(value) => {
        onChange(
          'show_images',
          (selectValue(value) || 'ask') as EmailInboxSettings['show_images'],
        )
      }}
    />

    <div className="scp-email-inbox-toggle-grid">
      {INBOX_TOGGLES.map(({ key, label }) => (
        <div key={key} className="scp-email-inbox-toggle-field">
          <span className="scp-pm-label">{label}</span>
          <ToggleSwitch
            id={`email-inbox-${key}`}
            aria-label={label}
            checked={data[key]}
            onChange={(checked) => onChange(key, checked)}
          />
        </div>
      ))}
    </div>
  </div>
)

export default InboxTab
